import { render, staticRenderFns } from "./MarkupTables.vue?vue&type=template&id=0bcbfb75&"
import script from "./MarkupTables.vue?vue&type=script&lang=js&"
export * from "./MarkupTables.vue?vue&type=script&lang=js&"
import style0 from "./MarkupTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports